import { IProperty } from './IProperty.interface';

export interface ITableWithFormOptions {
    properties: IProperty[];
    addNewItemText?: string;
    invalidText?: string;
    mandatoryText?: string;
}
